import Header from "@components/Header/Header"
import { useNavigate, useLocation } from "react-router"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import useBankManagement from "@hooks/useManageBank"
import LoadingModal from "@components/LoadingModal/LoadingModal"
import useRedemptionLimit from "@hooks/useRedemptionLimit"
import useBalance from "@hooks/useBalance"
import { setHeaderColor } from "@lib/telegram"
import { WHITE } from "@styles/colors"
import RedeemBankContent from "./RedeemBankContent"
import { Container } from "./RedeemBank.styles"

const RedeemBank = () => {
  const { supportedBanks, bankAsRedemptionOption, isLoading: isLoadingBanks, removeBank, reload } = useBankManagement()
  const { data: redemptionLimit, isLoading: isLoadingRedemptionLimit } = useRedemptionLimit()
  const { data: balance, isLoading: isLoadingBalance } = useBalance()

  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleRemoveBank = async (bank_uuid: string) => {
    await removeBank({ bank_uuid })
    await reload() // Reload the list after deletion
  }

  // Bank Redemption Limit
  const bankRemainingLimit = redemptionLimit && Number(redemptionLimit.redeem_request_remaining)
  const bankTotalDailyLimit = redemptionLimit && Number(redemptionLimit.total_redeem_request_limit)
  const preselectedBank = bankAsRedemptionOption.find(bank => bank.id === location.state?.bank_uuid)
  const prefilledAmount = location.state?.amount as number | undefined
  const splitDisbursementCountLimit = redemptionLimit && redemptionLimit.maximum_split_disbursements

  useEffect(() => {
    setHeaderColor(WHITE)
  }, [])

  return (
    <Container>
      <Header title={t('redeem.header')} showBackButton onBackClick={() => navigate('/transfer')} />

      <LoadingModal
        visible={
          isLoadingBanks ||
          isLoadingRedemptionLimit ||
          isLoadingBalance
        }
      />

      {
        !isLoadingBanks && !isLoadingBalance && !isLoadingRedemptionLimit && balance &&
        <RedeemBankContent
          currentBalance={balance.confirmed_balance}
          remainingLimit={bankRemainingLimit}
          totalDailyLimit={bankTotalDailyLimit}
          preselectedBank={preselectedBank}
          prefilledAmount={prefilledAmount}
          redemptionOptions={bankAsRedemptionOption || []}
          supportedBanks={supportedBanks}
          splitDisbursementCountLimit={splitDisbursementCountLimit}
          onRemoveBank={handleRemoveBank}
        />
      }

    </Container>
  )
}

export default RedeemBank
